import { defineStore } from 'pinia';

export const useGameStore = defineStore('game', {
    state: () => ({
        game: null, // Holds the game data
        isHost: false, // Holds host status
        user: null,
        isSaboteur: false,
        copyGameJoinCode: null,
        copyGameSource: null,
        hostShowSaboteurText: false,
        moderatorShowSaboteurText: false,

        // copyGameJoinCode: 2154,
        // copyGameId: 2339,
        // game: {
        //     allowedPlayers: 4,
        //     groupLimit: 4,
        //     codeLanguage: "",
        //     combinedText: "The sun hung low over the sea, casting golden rays upon the shores of Brobdingnag. Gulliver, now a giant in the eyes of the islanders, sat beside Glumdalclitch, his young caretaker, on a vast, grassy knoll.\n\nGulliver: \"Glumdalclitch, do you ever wonder what lies beyond these shores?\"\n\nGlumdalclitch: \"I've often thought, Mr. Gulliver, what marvels or perils might await beyond our sight.\"\n\nGulliver: \"In my travels, I've encountered many lands, each with its own peculiarities and wisdom. Yet, I often find myself pondering the simplicity of life here, despite its...unusual scale.\"\n\nGlumdalclitch, picking a flower as large as a tree to Gulliver: \"But isn't it the simplicity, Mr. Gulliver, that teaches us the most? Here, every creature, big or small, has its place.\"\n\nGulliver, watching a giant butterfly flutter by: \"Indeed, you've touched upon a truth. Perhaps, in the vastness of this world, it's the smallest lessons that echo the loudest.\"\n\nGlumdalclitch, smiling: \"Let us then, Mr. Gulliver, find joy in our smallness, for in our hearts, we are all giants.\"",
        //     discipline: undefined,
        //     discussionTime: 10,
        //     enableFinalReason: 1,
        //     enablePreliminaryReason: 1,
        //     fbGameDocId: "10GU3mbHJOqpXhetrVmZ",
        //     gameId: 2229,
        //     host: {
        //         id: 3167,
        //         name: 'Geetha'
        //     },
        //     inaccuracyLevels: {},
        //     joinCode: "5999",
        //     llm: null,
        //     originalText: "The sun hung low over the sea, casting golden rays upon the shores of Brobdingnag. Gulliver, now a giant in the eyes of the islanders, sat beside Glumdalclitch, his young caretaker, on a vast, grassy knoll.\n\nGulliver: \"Glumdalclitch, do you ever wonder what lies beyond these shores?\"\n\nGlumdalclitch: \"I've often thought, Mr. Gulliver, what marvels or perils might await beyond our sight.\"\n\nGulliver: \"In my travels, I've encountered many lands, each with its own peculiarities and wisdom. Yet, I often find myself pondering the simplicity of life here, despite its...unusual scale.\"\n\nGlumdalclitch, picking a flower as large as a tree to Gulliver: \"But isn't it the simplicity, Mr. Gulliver, that teaches us the most? Here, every creature, big or small, has its place.\"\n\nGulliver, watching a giant butterfly flutter by: \"Indeed, you've touched upon a truth. Perhaps, in the vastness of this world, it's the smallest lessons that echo the loudest.\"\n\nGlumdalclitch, smiling: \"Let us then, Mr. Gulliver, find joy in our smallness, for in our hearts, we are all giants.\"",
        //     readingTime: 5,
        //     realTextId: 8154,
        //     realTextLabel: "B",
        //     textTitle: "Gulliver's Travels",
        //     texts: [{
        //         content: "The sun hung low over the sea, casting golden rays upon the shores of Brobdingnag. Gulliver, now a giant in the eyes of the islanders, sat beside Glumdalclitch, his young caretaker, on a vast, grassy knoll.\n\nGulliver: \"Glumdalclitch, do you ever wonder what lies beyond these shores?\"\n\nGlumdalclitch: \"I've often thought, Mr. Gulliver, what marvels or perils might await beyond our sight.\"\n\nGulliver: \"In my travels, I've encountered many lands, each with its own peculiarities and wisdom. Yet, I often find myself pondering the simplicity of life here, despite its...unusual scale.\"\n\nGlumdalclitch, picking a flower as large as a tree to Gulliver: \"But isn't it the simplicity, Mr. Gulliver, that teaches us the most? Here, every creature, big or small, has its place.\"\n\nGulliver, watching a giant butterfly flutter by: \"Indeed, you've touched upon a truth. Perhaps, in the vastness of this world, it's the smallest lessons that echo the loudest.\"\n\nGlumdalclitch, smiling: \"Let us then, Mr. Gulliver, find joy in our smallness, for in our hearts, we are all giants.\"",
        //         id: 8151,
        //         label: "A",
        //     },
        //     {
        //         content: "Upon a hill overlooking the island of Laputa, a group of Laputian astronomers gather around a peculiar machine that resembles a giant, ornate kaleidoscope. The sky above is a tapestry of swirling clouds and stars, the city's floating nature making it seem as if the heavens themselves are within arm's reach.\n\nProfessor Flimnap, peering through the kaleidoscope, adjusts the lens with a slight frown: \"Curious, the stars align in a manner most...unusual today. They suggest a change in the air, or perhaps in our very minds.\"\n\nLord Munodi, standing nearby, chuckles softly: \"Perhaps, Flimnap, it's merely the dust in your device. Or could it be that your mind seeks patterns where none exist?\"\n\nA young scholar, eager to impress, steps forward: \"Might I suggest, my lords, that this could be a sign of the coming 'Great Eclipse'? The texts speak of such alignments, do they not?\"\n\nFlimnap, not looking away from his device, replies with a hint of irritation: \"Eclipses, yes, but not like this. This pattern... it's as if the stars are in jest, mocking our very science.\"\n\nLord Munodi, now intrigued, steps closer: \"A jest, you say? Perhaps the universe has a sense of humor after all, or maybe we've been looking at it all wrong.\"\n\nThe young scholar, with a hopeful tone: \"Could it be, then, that our understanding of the cosmos is but a child's play?\"\n\nFlimnap, finally turning from his device, looks at them both with a mix of amusement and skepticism: \"Or perhaps, gentlemen, we are all merely characters in someone else's narrative, our actions and thoughts preordained by an unseen author.\"",
        //         id: 8154,
        //         label: "B"
        //     },
        //     {
        //         content: "qwerty",
        //         id: 8152,
        //         label: "C"
        //     },
        //     {
        //         content: "zxcvb",
        //         id: 8153,
        //         label: "D"
        //     }
        //     ],
        //     uniqueTextId: [8151, 8154, 8152, 8153],
        //  //     playerStructure: {
        //  //             docId: "somerandom1",
        //  //             id: 2324,
        //  //             username: "Player 1 big name that no one knows",
        //  //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //  //             joineddAt: "timestamp",
        //  //             status: "Ready",
        //  //             score: 4,
        //  //             prelimVotedAt: "timestamp",
        //  //             votedAt: "timestamp",
        //  //             textVotedAt: "timestamp",
        //  //             votedTextId: 8151,
        //  //         },
        //     players: [
        //         {
        //             docId: "somerandom1",
        //             id: 2324,
        //             username: "Player 1 big name that no one knows",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: 4,
        //             groupId: 1,
        //             votedTextId: 8151,
        //             prelimVotedAt: "timestamp",
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2325,
        //             username: "Player 2325",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=2325",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: 3,
        //             groupId: 1,
        //         },
        //         {
        //             docId: "somerandom1",
        //             id: 2326,
        //             username: "Player 2326",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=2326",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: 7,
        //             groupId: 2,
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2327,
        //             username: "Player 2327",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=2327",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: 1,
        //             groupId: 2,
        //         },
        //         {
        //             docId: "somerandom1",
        //             id: 2328,
        //             username: "Player 2328",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=2328",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: -4,
        //             groupId: 2,
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2329,
        //             username: "Player 2",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=qwerty",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: -1,
        //             groupId: 2,
        //         },
        //         {
        //             docId: "somerandom1",
        //             id: 2330,
        //             username: "Player 1",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: 0,
        //             groupId: 2,
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2331,
        //             username: "Player 2",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=qwerty",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 2,
        //         },
        //         {
        //             docId: "somerandom1",
        //             id: 2332,
        //             username: "Player 1",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 3,
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2333,
        //             username: "Player 2",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=qwerty",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 4,
        //         },
        //         {
        //             docId: "somerandom1",
        //             id: 2334,
        //             username: "Player 1",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 4,
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2335,
        //             username: "Player 2",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=qwerty",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 4,
        //         },
        //         {
        //             docId: "somerandom1",
        //             id: 2336,
        //             username: "Player 1",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 4,
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2337,
        //             username: "Player 2",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=qwerty",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 5,
        //         },
        //         {
        //             docId: "somerandom1",
        //             id: 2338,
        //             username: "Player 1",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 5,
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2339,
        //             username: "Player 2",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=qwerty",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 5,
        //         },
        //         {
        //             docId: "somerandom1",
        //             id: 2340,
        //             username: "Player 1",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 5,
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2341,
        //             username: "Player 2",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=qwerty",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 5,
        //         },
        //         {
        //             docId: "somerandom1",
        //             id: 2342,
        //             username: "Player 1",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 5,
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2343,
        //             username: "Player 2",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=qwerty",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 6,
        //         },
        //         {
        //             docId: "somerandom1",
        //             id: 2344,
        //             username: "Player 1",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             groupId: 6,
        //         },
        //         {
        //             docId: "somerandom2",
        //             id: 2345,
        //             username: "Player 2",
        //             avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=qwerty",
        //             joineddAt: "timestamp",
        //             status: "Ready",
        //             score: null,
        //             prelimVotedAt: "timestamp",
        //             votedAt: "timestamp",
        //             groupId: 7,
        //         },

        //     ],
        //     messages: [
        //         {
        //             "docId": "qwert",
        //             "userName": "Geetha",
        //             "userId": 1,
        //             "isHost": true,
        //             "createdAt": "firestore.SERVER_TIMESTAMP",
        //             "text": "Message from host",
        //             "userAvatar": "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Geetha"
        //         },
        //         {
        //             "docId": "asdfg",
        //             "userName": "Player 1",
        //             "userId": 3129,
        //             "isHost": false,
        //             "createdAt": "firestore.SERVER_TIMESTAMP",
        //             "text": "Message from player 1 Message from player 1 Message from player 1 Message from player 1 Message from player 1",
        //             "userAvatar": "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 1"
        //         },
        //         {
        //             "docId": "zxcvb",
        //             "userName": "Player 2",
        //             "userId": 3,
        //             "isHost": false,
        //             "createdAt": "firestore.SERVER_TIMESTAMP",
        //             "text": "Message from player 2. that is really really long bitch. do you even know oyur shit?",
        //             "userAvatar": "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 2"
        //         },
        //     ],
        //     preliminaryVotes: [
        //         {
        //             playerId: 1,
        //             playerName: "Player 1",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 1_1",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 1,
        //         },
        //         {
        //             playerId: 2,
        //             playerName: "Player 2",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 2_2",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 1,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 2,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 3,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 3,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 3,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 3,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 3,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 3,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 4,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 4,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 5,
        //         },
        //         {
        //             playerId: 3,
        //             playerName: "Player 3",
        //             playerAvatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Player 3_3",
        //             primaryTextId: 8151,
        //             secondaryTextId: 8153,
        //             voteReason: "Some random reson!!",
        //             groupId: 5,
        //         },
        //     ],
        //     saboteurVotes: {  // @see: not in use right now
        //         "-1": 2,      // Votes for "No Saboteur" (players believing there's no saboteur)
        //         "2324": 3,    // Player with ID 2324 received 3 votes
        //         "2325": 1,    // Player with ID 2325 received 1 vote
        //         "2326": 0     // Player with ID 2326 received no votes
        //     },
        //     saboteur: {
        //         id: 2325,
        //         name: "Player 2",
        //         avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=qwerty",
        //     },
        //     topScorer:
        //     {
        //         docId: "somerandom1",
        //         id: 2324,
        //         username: "Player 1 big name that no one knows",
        //         avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=somerandom1",
        //         joineddAt: "timestamp",
        //         status: "Ready",
        //         score: 4
        //     },
        //     // votedPlayersCount: 0, // @see: not in use anymore
        //     prelimVotedPlayersCount: 0,
        //     // phase: "JOIN",
        //     // phase: "READ",
        //     // phase: "PRELIMINARY_VOTE",
        //     // phase: "DISCUSS",
        //     // phase: "VOTE",
        //     // phase: "REVEAL",
        //     phase: "DEBRIEF",
        // },
        // isHost: true,
        // user: {
        //     id: 2325,
        //     name: "Geetha",
        //     avatar: "https://api.dicebear.com/7.x/bottts-neutral/svg?radius=20&scale=80&seed=Geetha",
        //     score: 10,
        //     position: 5,
        // },
        // isSaboteur: true,
    }),
    getters: {
        playersById: (s) => {
            const m = {};
            for (const p of s.game?.players || []) m[p.id] = p;
            return m;
        },
        player: (s) => {
            return s.user ? s.playersById[s.user.id] : null;
        },
        canRevealRoleRealText: (s) => {
            return (s.isHost && s.hostShowSaboteurText) || s.isSaboteur;
        },
        shouldHighlightRealTextInBoard: (s) => {
                if (s.isHost) return s.hostShowSaboteurText;
                if (s.player?.role === "moderator") return s.moderatorShowSaboteurText;
                return false;
        },
        displayRealTextId() {
            const publicRevealPhases = ["REVEAL", "DEBRIEF"];
            if (publicRevealPhases.includes(this.game?.phase)) {
                return this.game?.realTextId ?? null;
            }
            if (this.shouldHighlightRealTextInBoard) {
                return this.game?.realTextId ?? null;
            }
            return null;
        },

        displayRealTextLabel() {
            const publicRevealPhases = ["REVEAL", "DEBRIEF"];
            if (publicRevealPhases.includes(this.game?.phase)) {
                return this.game?.realTextLabel ?? '';
            }
            if (this.shouldHighlightRealTextInBoard) {
                return this.game?.realTextLabel ?? '';
            }
            return '';
        },
        saboteurRealTextLabel() {
            const realId = Number(this.game?.realTextId);

            const matchedText = (this.game?.texts || []).find(
                (text) => Number(text.id) === realId
            );

            return matchedText?.label ?? '';
        }
    },
    actions: {
        restoreHydratedGame(data) {
            if (!this.game) {
                this.game = {};
            }

            this.game = {
                ...this.game,
                ...data,
            };

            this.isHost = data.role === "host";

            if (data.players) {
                this.game.players = data.players;
            }

            if (data.host) {
                this.game.host = data.host;
            }

            if (data.phase) {
                this.game.phase = data.phase;
            }

            if (data.realTextId != null) {
                this.game.realTextId = data.realTextId;

                this.updateRealText(data.realTextId);
            }
        },
        setCopyGameJoinCode(joinCode) {
            this.copyGameJoinCode = joinCode;
        },
        clearCopyGameJoinCode() {
            this.copyGameJoinCode = null;
        },
        setCopyGameSource(gameData) {
            this.copyGameSource = gameData;
        },
        clearCopyGameSource() {
            this.copyGameSource = null;
        },
        setGameData(gameData, isHost = false, user, isSaboteur = false) {
            this.game = gameData;
            this.isHost = isHost;
            this.user = user;
            this.isSaboteur = isSaboteur;
            this.hostShowSaboteurText = false;
        },
        clearGameData() {
            this.game = null;
            this.isHost = false;
            this.user = null;
            this.isSaboteur = false;
            this.hostShowSaboteurText = false;
        },
        toggleHostShowSaboteurText() {
            this.hostShowSaboteurText = !this.hostShowSaboteurText;
        },
        toggleModeratorShowSaboteurText() {
            this.moderatorShowSaboteurText = !this.moderatorShowSaboteurText;
        },
        forceHideSaboteurText() {
            this.hostShowSaboteurText = false;
        },
        addMessage(msgObj) {
            if (!this.game) {
                console.error("Game data is not initialized.");
                return;
            }
            if (!Array.isArray(this.game.messages)) {
                console.error("Messages array is not initialized.");
                this.game.messages = []; // Initialize messages array if it's not already an array
            }
            this.game.messages.push(msgObj); // Correct way to add new messages
        },
        updateMessages(messagesArr) {
            this.game.messages = messagesArr;
        },
        updatePlayers(playersArr) {
            if (!this.game) return;

            const existingById = {};
            for (const p of this.game.players || []) {
                existingById[p.id] = p;
            }

            this.game.players = playersArr.map((livePlayer) => {
                const existing = existingById[livePlayer.id] || {};

                return {
                ...existing,
                ...livePlayer,
                score: existing.score ?? livePlayer.score ?? 0,
                position: existing.position ?? livePlayer.position ?? null,
                };
            });
        },
        updateGamePhase(phase) {
            if (!this.game) {
                console.warn("updateGamePhase called but game is null");
                return;
            }

            this.game.phase = phase;
            },
        addPreliminaryVotesList(prelimVotes) {
            // console.log("🚀 addPreliminaryVotesList triggered with: ", prelimVotes);
            this.game.preliminaryVotes = prelimVotes;
            // console.log("🛠 Updated game.preliminaryVotes: ", this.game.preliminaryVotes);
        },
        updatePlayerScores(scores) {
            // console.log("existing array: ", this.game.players);
            // console.log("new incoming array: ", scores);

            // Create a Map for quick lookup (id -> score)
            const scoresMap = new Map(scores.map(player => [player.id, player.score ?? 0]));
            // console.log("scoresMap: ", scoresMap);

            // Update existing players using the map
            const updatedPlayers = this.game.players.map(player => ({
                ...player,
                score: scoresMap.has(player.id) ? scoresMap.get(player.id) : player.score ?? 0 // Convert null to 0
            }));

            // console.log("Updated players array: ", updatedPlayers);

            // Assign the updated players list in a reactive way
            // Object.assign(this.game.players, updatedPlayers);
            this.game.players = updatedPlayers;

            // // Update existing players using the map
            // this.game.players = this.game.players.map(player => {
            //     return scoresMap.has(String(player.id))
            //         ? { ...player, score: scoresMap.get(String(player.id)) }
            //         : player; // If no score update, return player as is
            // });

            // console.log("Updated players array: ", this.game.players);

            // Find the top scorer
            const topScorer = updatedPlayers.reduce((maxPlayer, currentPlayer) => {
                const currentScore = typeof currentPlayer.score === 'number' ? currentPlayer.score : -Infinity;
                const maxScore = typeof maxPlayer.score === 'number' ? maxPlayer.score : -Infinity;
                return currentScore > maxScore ? currentPlayer : maxPlayer;
            }, { score: -Infinity });

            // console.log("🏆 topScorer: ", topScorer);
            this.game.topScorer = topScorer;

            // Get the current user's score and position
            const sortedPlayers = [...this.game.players].sort((a, b) => {
                const scoreA = typeof a.score === 'number' ? a.score : -Infinity;
                const scoreB = typeof b.score === 'number' ? b.score : -Infinity;
                return scoreB - scoreA; // Descending order (highest score first)
            });

            if (!this.user || !this.user.id) return;

            const currentUserIndex = sortedPlayers.findIndex(
            player => Number(player.id) === Number(this.user.id)
            );

            if (currentUserIndex !== -1) {
                const currentUserScore = sortedPlayers[currentUserIndex].score ?? 0; // Default to 0 if score is undefined
                const currentUserPosition = currentUserIndex + 1; // Positions are 1-based

                // console.log(`👤 Current User: ${this.user.name}`);
                // console.log(`🏅 Position: ${currentUserPosition}`);
                // console.log(`🔢 Score: ${currentUserScore}`);

                // this.user = {
                //     ...this.user,
                //     score: currentUserScore,
                //     position: currentUserPosition
                // }
                Object.assign(this.user, {
                    score: currentUserScore,
                    position: currentUserPosition
                });
            } else {
                console.warn("Current user not found in the players list.");
            }
        },
        updateAllGroupsPlayerScores(playersMap) {
            const updatedPlayers = this.game.players.map((player) => {
                const info = playersMap[player.id] || playersMap[String(player.id)] || {};

                return {
                ...player,
                score: info.score ?? player.score ?? 0,
                position: info.position ?? player.position ?? Infinity,
                breakdown: info.breakdown ?? [],
                };
            });

            this.game.players = updatedPlayers;
        },

        updateGroupPlayersScores(playersMap) {
            const updatedPlayers = this.game.players.map((player) => {
                const info = playersMap[player.id] || playersMap[String(player.id)] || {};

                return {
                ...player,
                score: info.score ?? player.score ?? 0,
                position: info.position ?? player.position ?? Infinity,
                breakdown: info.breakdown ?? [],
                };
            });

            this.game.players = updatedPlayers;
        },
        // @see: not in use right now
        // addVoteResults(textVotes, saboteurVotes) {
        //     // console.log("textVotes: ", textVotes)
        //     this.game.texts = this.game.texts.map((text) => {
        //         return { ...text, votes: textVotes[String(text.id)] ?? null }
        //     });

        //     // console.log("saboteurVotes: ", saboteurVotes);
        //     this.game.saboteurVotes = saboteurVotes;
        // },
        // @see: not in use right now
        // addSaboteurVotes(saboteurVotes) {
        //     this.game.saboteurVotes = saboteurVotes;
        // },
        setSaboteurStatus(isSaboteur = true) {
            this.isSaboteur = isSaboteur;
        },
        setSaboteur(saboteurObj) {
            this.game.saboteur = saboteurObj;
        },
        updateSaboteur(saboteurId) {
            if (saboteurId) {
                let saboteur = this.game.players.find((player) => player.id == saboteurId)

                if (saboteur) {
                    this.game.saboteur = {
                        id: saboteur.id,
                        name: saboteur.username,
                        avatar: saboteur.avatar
                    }
                } else {
                    console.error(`No player found with ID ${saboteurId}`);
                }

            } else {
                // there might be no saboteur
            }
        },
        updateRealText(realTextId) {
            if (realTextId) {
                this.game.realTextId = realTextId;

                const realText = this.game.texts.find(text => text.id == realTextId);
                this.game.realTextLabel = realText ? realText.label : '';
            } else {
                // there must a real text
                console.error("Missing real text")
            }
        },
        updatePrelimVotedPlayersCount(count) {
            this.game.prelimVotedPlayersCount = count;
        },
        // updateVotedPlayersCount(count) {
        //     this.game.votedPlayersCount = count;
        // },
    },
});
